<template>
  <button
    type="button"
    role="switch"
    :aria-checked="modelValue"
    class="q-toggle"
    :class="{ 'q-toggle--on': modelValue, 'q-toggle--disabled': disabled }"
    :disabled="disabled"
    @click="toggle"
  >
    <span class="q-toggle-knob"></span>
  </button>
</template>

<script>
export default {
  name: "QToggle",
  props: {
    modelValue: { type: Boolean, default: false },
    disabled:   { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "change"],
  methods: {
    toggle() {
      if (this.disabled) return;
      const newVal = !this.modelValue;
      this.$emit("update:modelValue", newVal);
      this.$emit("change", newVal);
    },
  },
};
</script>

<style scoped>
.q-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 48px;
  height: 26px;
  border-radius: 13px;
  border: none;
  background: var(--q-border-md, #2a3a4a);
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
  padding: 0;
  vertical-align: middle;
}
.q-toggle--on  { background: var(--q-green, #2ee27f); }
.q-toggle--disabled { opacity: 0.45; cursor: not-allowed; }
.q-toggle-knob {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.3);
  transition: left 0.2s;
}
.q-toggle--on .q-toggle-knob { left: 25px; }
</style>
